import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import InsertChartIcon from '@material-ui/icons/InsertChartOutlined';
import DoneIcon from '@material-ui/icons/Done';
const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.green[600],
    height: 56,
    width: 56
  }
}));

const InvoiceDownload = (props,{ className, ...rest }) => {
  const classes = useStyles();
 console.log("props inv download",props.matrix);
  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
               PAYMENT INITIATED THIS MONTH
             {/* VALIDATED */}
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
             {props.matrix.Totalpaymentinit}
            </Typography>
          </Grid>
          {/* <Grid item>
            <Avatar className={classes.avatar}>
              <DoneIcon />
            </Avatar>
          </Grid> */}
        </Grid>
      </CardContent>
    </Card>
  );
};

InvoiceDownload.propTypes = {
  className: PropTypes.string
};

export default InvoiceDownload;
